import { basicURL } from "../../apiManager/APIConfig";

export function getAuthorLabel(item) {
  if (!item?.user) return "User";
  return `${item.user.first_name || ""} ${item.user.last_name || ""}`.trim() || "User";
}

export function toAbsoluteUrl(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  const base = String(basicURL || "").replace(/\/+$/, "");
  const path = s.replace(/^\/+/, "");
  return `${base}/${path}`;
}

function getQuestionFiles(item) {
  const raw = item?.files ?? item?.Files ?? [];
  return Array.isArray(raw) ? raw.filter(Boolean) : [];
}

function isVideoFile(f) {
  const mime = String(f?.type || f?.mime || "").toLowerCase();
  const ref = `${f?.name || ""} ${f?.alias || ""} ${f?.url || ""} ${f?.path || ""}`.toLowerCase();
  return mime.startsWith("video/") || /\.(mp4|mov|m4v|webm)(\?|$|#)/i.test(ref);
}

export function getMediaInfo(item) {
  const allFiles = getQuestionFiles(item);
  const fileVideo = allFiles.find(isVideoFile);
  const rootVideo = item?.video_url || item?.videoUrl || item?.uploaded_file?.url || "";
  const videoUrl = fileVideo?.url || rootVideo || "";

  if (videoUrl) {
    const nonVideo = allFiles.filter((f) => f?.url && !isVideoFile(f));
    const posterCandidate =
      item?.thumbnail_url || item?.thumbnailUrl || item?.picture_url || nonVideo?.[0]?.url || "";
    return {
      url: toAbsoluteUrl(videoUrl),
      posterUrl: toAbsoluteUrl(posterCandidate),
      isVideo: true,
    };
  }

  const imageCandidate =
    item?.image_url ||
    item?.imageUrl ||
    item?.picture_url ||
    item?.uploaded_file?.url ||
    allFiles.find((f) => f?.url)?.url ||
    "";
  return { url: toAbsoluteUrl(imageCandidate), posterUrl: "", isVideo: false };
}

const AVATAR_COLORS = ["#0061FE", "#7C3AED", "#DB2777", "#EA580C", "#059669", "#0891B2", "#4F46E5"];

export function avatarColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function initials(name) {
  const parts = name.split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] || "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase() || "U";
}

export function getAvatarUrl(item) {
  const u = item?.user || {};
  return toAbsoluteUrl(u.picture_url || u.avatar_url || u.profile_image || u.image || "");
}

export function timeAgo(value) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  const sec = Math.round((Date.now() - date.getTime()) / 1000);
  if (sec < 60) return "Just now";
  const steps = [
    [60, "m"],
    [24, "h"],
    [7, "d"],
  ];
  let n = Math.floor(sec / 60);
  for (const [limit, unit] of steps) {
    if (n < limit) return `${n}${unit} ago`;
    n = Math.floor(n / limit);
  }
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function compactCount(n) {
  const v = Number(n) || 0;
  if (v < 1000) return String(v);
  return `${(v / 1000).toFixed(v < 10000 ? 1 : 0).replace(/\.0$/, "")}k`;
}
